module.exports = __webpack_public_path__ + "img/185.fd235d13.jpg";